<template>
  <div class="pt-[125px] md:pt-[145px] lg:pt-[185px] xl:pt-[195px] text-center">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
      <h1
        class="mb-0 leading-[1.2] text-[32px] md:text-[40px] lg:text-[50px] xl:text-[60px] -tracking-[.5px] md:-tracking-[1px] xl:-tracking-[1.5px]"
      >
        {{ pageTitle }}
      </h1>
      <div
        class="absolute bottom-0 -z-[1] ltr:-right-[30px] rtl:-left-[30px] blur-[250px]"
      >
        <img src="@/assets/images/front-pages/shape3.png" alt="shape3" />
      </div>
      <div
        class="absolute -top-[220px] -z-[1] ltr:-left-[50px] rtl:-right-[50px] blur-[150px]"
      >
        <img src="@/assets/images/front-pages/shape5.png" alt="shape3" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PageTitle",
  props: ["pageTitle"],
});
</script>
